import { createAsyncThunk } from "@reduxjs/toolkit";
import Axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { setIsSpinnerVisible } from "store/modules/AppConfig/index.store";

import ordersApi from "services/ordersApi";

import i18next from "i18next";

import { parsePersistedDateFromObject } from "utils/parsePersistedDateFromObject";
import {
  OrdersResponse,
  OrdersRequest,
  OrderUpdateRequest,
  OrderAddDriveRequest,
  OrderProps,
} from "./types.store";

export const handleGetOrdersRequest = createAsyncThunk<
  OrdersResponse,
  OrdersRequest
>("getOrders", async (dataOrders, { rejectWithValue, dispatch }) => {
  try {
    const { data } = await ordersApi.get(
      `v1/dealers/${dataOrders.dealerId}/orders?state=all`,
    );

    data?.forEach((order: OrderProps) => {
      parsePersistedDateFromObject(order, "createdAt");
    });

    return data;
  } catch (err) {
    if (Axios.isAxiosError(err) && err && err.response) {
      return rejectWithValue(err.response.data);
    }
    return rejectWithValue(err);
  } finally {
    dispatch(setIsSpinnerVisible(false));
  }
});

export const handleUpdateOrderRequest = createAsyncThunk<
  null,
  OrderUpdateRequest
>("updateOrder", async (data, { rejectWithValue, dispatch }) => {
  try {
    dispatch(setIsSpinnerVisible(true));
    const payload = data.body
      ? {
          ...data.body,
          reasonNotProvidePin: data.reasonNotProvidePin
            ? data.reasonNotProvidePin
            : undefined,
          pin: data.pin ? data.pin : undefined,
        }
      : {
          reasonNotProvidePin: data.reasonNotProvidePin
            ? data.reasonNotProvidePin
            : undefined,
          pin: data.pin ? data.pin : undefined,
          consumerId: data.consumerId,
          origin: "DealerPortal",
          eta: data?.eta ? data?.eta : null,
        };
    await ordersApi.post(
      `v1/dealers/${data.dealerId}/orders/${data.orderId}/${data.type}`,
      payload,
    );

    return null;
  } catch (err) {
    toast(i18next.t("failedInitiateOrderPleaseAgain").toString(), {
      type: "error",
      autoClose: false,
    });

    if (Axios.isAxiosError(err) && err && err.response) {
      return rejectWithValue(err.response.data);
    }
    return rejectWithValue(err);
  } finally {
    dispatch(setIsSpinnerVisible(false));
  }
});

export const handleAddDriveOrderRequest = createAsyncThunk<
  null,
  OrderAddDriveRequest
>("updateOrder", async (data, { rejectWithValue, dispatch }) => {
  try {
    dispatch(setIsSpinnerVisible(true));

    const driverPayload = data.clearDriver
      ? {}
      : { id: data.driverId, name: data.driverName };

    await ordersApi.put(
      `v1/dealers/${data.dealerId}/orders/${data.orderId}/driver`,
      { driver: driverPayload },
    );

    return null;
  } catch (err) {
    toast(i18next.t("failedAssignDriver").toString(), {
      type: "error",
      autoClose: false,
    });

    if (Axios.isAxiosError(err) && err && err.response) {
      return rejectWithValue(err.response.data);
    }
    return rejectWithValue(err);
  } finally {
    dispatch(setIsSpinnerVisible(false));
  }
});
